import React, { useEffect, useContext, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTour } from '@reactour/tour';
import classNames from 'classnames';
import { useMeasure } from 'react-use';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Carousel from '../../../components/bootstrap/Carousel';
import CarouselSlide from '../../../components/bootstrap/CarouselSlide';
import Pic from '../../../assets/img/wanna/richie/richie.png';
import Pic2 from '../../../assets/img/wanna/richie/richie2.png';
import Pic3 from '../../../assets/img/wanna/richie/richie3.png';
import Pic4 from '../../../assets/img/wanna/richie/richie4.png';
import Pic5 from '../../../assets/img/wanna/richie/richie5.png';
import Pic6 from '../../../assets/img/wanna/richie/richie6.png';
import Pic7 from '../../../assets/img/wanna/richie/richie7.png';
import Pic8 from '../../../assets/img/wanna/richie/richie8.png';
import SubHeader, {
	SubHeaderLeft,
	SubHeaderRight,
	SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import Button from '../../../components/bootstrap/Button';
import CommonGridProductItem from '../../common/CommonGridProductItemSwl';
import Card, { CardActions } from '../../../components/bootstrap/Card';
import { userAuth } from '../../../contexts/userContext';
import { CartContext } from '../../../contexts/CartContext';
import useDarkMode from '../../../hooks/useDarkMode';
import apiServicewt from '../../../api/apiServicewt';
import { motion, AnimatePresence } from 'framer-motion';
import { useMediaQuery } from '@mui/material';
import { layoutMenu } from '../../../menu';
import '../../presentation/auth/Home.css';
import apiService from '../../../api/apiService';
import { useTranslation } from 'react-i18next';
import LANG, { getLangWithKey } from '../../../lang';
import useSortableData from '../../../hooks/useSortableData';
import Select from '../../../components/bootstrap/forms/Select';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import CustomSearchInput from '../demo-pages/helper/CustomSearchInput';
import SelectOption from '../../../components/bootstrap/Option';
import { PER_COUNT } from '../../../components/PaginationButtonsdb';
import NoItems from '../../../components/NoItems';
import CommonProductView from '../../common/CommonProductView';
import Popovers from '../../../components/bootstrap/Popovers';
import { useLanguageSwitch } from '../../../contexts/LanguageSwitchContext';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import Input from '../../../components/bootstrap/forms/Input';
import {
	Skeleton,
	InputSkeleton,
	SelectSkeleton,
	ServiceCardSkeleton,
	SkeletonLine,
} from '../../../components/common/Skeleton';
import showNotification from '../../../components/extras/showNotification';
import Icon from '../../../components/icon/Icon';
import Logo from '../../../components/Logo';
import { FormControlLabel, Switch } from '@mui/material';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import {
	changeGoogleTranslateLanguage,
	getStoredLanguage,
} from '../../../helpers/languageSwitch';

const tabStyles = {
	container: {
		display: 'inline-flex',
		borderRadius: '999px',
		padding: '6px',
		background: 'rgba(0,0,0,0.03)',
	},
	tab: (active) => ({
		padding: '8px 18px',
		borderRadius: '999px',
		cursor: 'pointer',
		color: active ? '#ffffff' : '#222',
		background: active ? '#6c5dd3' : 'transparent',
		fontWeight: 600,
		margin: '2px',
		boxShadow: active ? '0 2px 6px rgba(108,93,211,0.25)' : 'none',
	}),
};

const Home = () => {
	// Ref to skip first intersection event
	const isFirstLoadRef = useRef(true);
	// Ref to hold observer instance for cleanup
	const observerRef = useRef(null);
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const [ref, { height }] = useMeasure();
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'dark'];
	const [selectedImage, setSelectedImage] = useState(null);

	const [data, setData] = useState([]);
	const [scurrency, setScurrency] = useState([]);
	const [vslider, setVslider] = useState(null);
	const [products, setProducts] = useState([]);
	const [activeTab, setActiveTab] = useState('services');
	const [editItem, setEditItem] = useState(null);
	const [editPanel, setEditPanel] = useState(false);
	const [branches, setBranches] = useState([]);
	const [sitename, setSitename] = useState([]);
	const [branch, setbranch] = useState({ error: false, msg: t('*Required'), data: '' });
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	// Derived responsive flags
	const isMobile = windowWidth <= 576; // bootstrap-esque breakpoint
	const { token } = useContext(userAuth);
	const { itemsCount } = useContext(CartContext);
	const [hasGuestSession, setHasGuestSession] = useState(false);

	useEffect(() => {
		try {
			const storedGuestAuth = JSON.parse(localStorage.getItem('guest-user-auth'));
			setHasGuestSession(Boolean(storedGuestAuth?.session_key || storedGuestAuth?.guest_token));
		} catch (error) {
			setHasGuestSession(false);
		}
	}, []);

	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['25']);
	const [totalRows, settotalRows] = useState(25);
	const [isLoadingMore, setIsLoadingMore] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [isListLoading, setIsListLoading] = useState(true);
	const bottomRef = useRef(null);
	const [showScrollTop, setShowScrollTop] = useState(false);
	const requestIdRef = useRef(0);
	const controllerRef = useRef(null);
	const scrollAnimRef = useRef({ rafId: null, cancelHandler: null });
	// Prevent duplicate load triggers from IntersectionObserver
	const loadLockRef = useRef(false);
	const currentPageRef = useRef(1);
	// Refs mirroring state for stable IntersectionObserver callback
	const hasMoreRef = useRef(hasMore);
	const isLoadingMoreRef = useRef(isLoadingMore);
	const perPageRef = useRef(perPage);
	const isListLoadingRef = useRef(isListLoading);
	const hasLoadedFirstPageRef = useRef(false);
	const [totalRowsServices, setTotalRowsServices] = useState(null);
	const [totalRowsProducts, setTotalRowsProducts] = useState(null);
	const { items } = useSortableData(data);
	const [searchValue, setSearchValue] = useState('');
	const { isLangSwitchEnabled } = useLanguageSwitch();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const [empsearch, setempsearch] = useState({ error: false, msg: t('*Required'), data: '' });
	const [showFilters, setShowFilters] = useState(false);
	const [selectedLanguage, setSelectedLanguage] = useState(getStoredLanguage());
	const [cattableOption, setCatTableOption] = useState([]);

	// Applied category filters (services). For multi-select we store an array of ids.
	// Empty array means "All".
	const [catid, setCatid] = useState([]);
	// Applied (user-selected) price range for the CURRENT tab.
	// IMPORTANT: these must not be overwritten by API bounds when switching tabs/pagination.
	const [minprice, setMinprice] = useState(0);
	const [maxprice, setMaxprice] = useState(100);
	// Remember the last chosen range per tab so switching tabs can reset/restore cleanly
	const [servicesRange, setServicesRange] = useState(null); // {min,max}
	const [productsRange, setProductsRange] = useState(null); // {min,max}
	// Refs to avoid stale state during IntersectionObserver pagination callbacks
	const productsRangeRef = useRef(null);
	const servicesRangeRef = useRef(null);
	const [maxpriceamount, setMaxpriceamount] = useState(1000);
	// API-provided bounds for PRODUCTS (separate from services bounds)
	const [productsMinAvailable, setProductsMinAvailable] = useState(0);
	const [productsMaxAvailable, setProductsMaxAvailable] = useState(1000);
	// Track whether bounds have been loaded at least once per tab.
	// This lets the UI "wait" for API bounds instead of using placeholder defaults.
	const [servicesBoundsLoaded, setServicesBoundsLoaded] = useState(false);
	const [productsBoundsLoaded, setProductsBoundsLoaded] = useState(false);
	// Small, shared renderer for Theme + Language controls
	const ThemeLangControls = () => (
		<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
			<Popovers trigger='hover' desc='Dark / Light mode'>
				<Button
					{...styledBtn}
					icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
					onClick={() => setDarkModeStatus((prev) => !prev)}
					aria-label='Toggle theme'
					data-tour='dark-mode'
				/>
			</Popovers>
			{isLangSwitchEnabled && (
				<Dropdown>
					<DropdownToggle hasIcon={false}>
						<Button
							{...styledBtn}
							icon={getLangWithKey(selectedLanguage)?.icon}
							aria-label='Change language'
							data-tour='lang-selector'
						/>
					</DropdownToggle>
					<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
						{Object.keys(LANG).map((key) => (
							<DropdownItem key={LANG[key].lng}>
								<Button
									icon={LANG[key].icon}
									onClick={() => {
										if (controllerRef.current) controllerRef.current.abort();
										setActiveTab('products');
										setCurrentPage(1);
										setHasMore(true);
										setProducts([]);
										settotalRows(
											totalRowsProducts !== null ? totalRowsProducts : null,
										);
										fetchProductsWL(branch.data);
										changeLanguage(LANG[key].lng);
									}}>
									{LANG[key].text}
								</Button>
							</DropdownItem>
						))}
					</DropdownMenu>
				</Dropdown>
			)}
		</div>
	);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if (token?.session_key) {
			navigate('/services');
		}
	}, [token]);

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	useEffect(() => {
		const fetchata = async () => {
			const item = { action: 'get_category_menu_wl' };

			const flechdata = await apiServicewt(item, navigate);
			if (Array.isArray(flechdata.data)) {
				const temp = flechdata.data.map((ele) => ({
					value: ele.id,
					text: ele.catname,
				}));

				temp.unshift(
					{ value: 'all', text: 'All' },
					// {
					// 	value: 16,
					// 	text: 'Beard Trimming',
					// },
					// {
					// 	value: 17,
					// 	text: 'Shaving',
					// },
					// {
					// 	value: 18,
					// 	text: 'Facials',
					// },
					// {
					// 	value: 19,
					// 	text: 'Hair Coloring',
					// },
					// {
					// 	value: 20,
					// 	text: 'Scalp Treatments',
					// },
					// {
					// 	value: 21,
					// 	text: 'Threading',
					// },
					// {
					// 	value: 22,
					// 	text: 'Manicure',
					// },
					// {
					// 	value: 23,
					// 	text: 'Pedicure',
					// },
					// {
					// 	value: 24,
					// 	text: 'Head Massage',
					// },
					// {
					// 	value: 25,
					// 	text: 'Bridal Grooming',
					// },
				);
				setCatTableOption(temp);
			}
		};

		fetchata();
	}, []);

	useEffect(() => {
		localStorage.setItem('theme', darkModeStatus ? 'dark' : 'light');
		document.documentElement.setAttribute('theme', darkModeStatus ? 'dark' : 'light');
	}, [darkModeStatus]);

	const saveHomeCache = (selectedId) => {
		try {
			const cache = {
				branch: branch.data,
				activeTab,
				data,
				products,
				totalRowsServices,
				totalRowsProducts,
				perPage,
				currentPage,
				totalRows,
				selectedId: selectedId || null,
				fromDetail: true,
				savedAt: Date.now(),
			};
			sessionStorage.setItem('home-cache', JSON.stringify(cache));
		} catch (err) {}
	};

	const logbtn = windowWidth < 500 ? 'ab' : 'cd';
	const isInitialServicesLoading =
		activeTab === 'services' &&
		(isListLoading || !hasLoadedFirstPageRef.current) &&
		data.length === 0;
	const isInitialProductsLoading =
		activeTab === 'products' &&
		(isListLoading || !hasLoadedFirstPageRef.current) &&
		products.length === 0;
	const showInitialHomeSkeleton = isInitialServicesLoading || isInitialProductsLoading;

	const changeLanguage = async (lang) => {
		const nextLanguage = await changeGoogleTranslateLanguage(lang);
		setSelectedLanguage(nextLanguage);

		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(nextLanguage)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(nextLanguage)?.text}`}</span>
			</span>,
		);
	};

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	// Keep refs in sync with state
	useEffect(() => {
		hasMoreRef.current = hasMore;
	}, [hasMore]);
	useEffect(() => {
		isLoadingMoreRef.current = isLoadingMore;
	}, [isLoadingMore]);
	useEffect(() => {
		perPageRef.current = perPage;
	}, [perPage]);
	useEffect(() => {
		isListLoadingRef.current = isListLoading;
	}, [isListLoading]);
	useEffect(() => {
		currentPageRef.current = currentPage;
	}, [currentPage]);
	useEffect(() => {
		productsRangeRef.current = productsRange;
	}, [productsRange]);
	useEffect(() => {
		servicesRangeRef.current = servicesRange;
	}, [servicesRange]);

	useEffect(() => {
		const onScroll = () => {
			setShowScrollTop(window.scrollY > window.innerHeight);
		};
		window.addEventListener('scroll', onScroll);

		// Disconnect previous observer if exists
		if (observerRef.current) {
			observerRef.current.disconnect();
			observerRef.current = null;
		}

		// Only skip first intersection on mount/tab change
		isFirstLoadRef.current = true;

		if (bottomRef.current) {
			observerRef.current = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) return;

						if (isFirstLoadRef.current) {
							isFirstLoadRef.current = false;
							return;
						}

						if (
							hasMoreRef.current &&
							!isLoadingMoreRef.current &&
							!loadLockRef.current &&
							hasLoadedFirstPageRef.current
						) {
							loadLockRef.current = true;
							const next = (currentPageRef.current || 1) + 1;
							currentPageRef.current = next;
							setCurrentPage(next);
							const p = handlefunction(next, perPageRef.current);
							if (p && typeof p.finally === 'function') {
								p.finally(() => {
									loadLockRef.current = false;
								});
							} else {
								loadLockRef.current = false;
							}
						}
					});
				},
				{ root: null, rootMargin: '200px', threshold: 0.1 },
			);
			observerRef.current.observe(bottomRef.current);
		}

		return () => {
			window.removeEventListener('scroll', onScroll);
			if (observerRef.current) {
				observerRef.current.disconnect();
				observerRef.current = null;
			}
		};
	}, [activeTab]);

	useEffect(() => {
		const fetchata = async () => {
			const item = { action: 'get_branches_list_wl' };

			const flechdata = await apiServicewt(item, navigate);
			setSitename(flechdata);
			if (Array.isArray(flechdata.data)) {
				const temp = flechdata.data.map((ele) => ({
					value: ele.branch_id,
					text: ele.branch_name,
				}));

				setBranches(temp);
				const defaultBranch = flechdata.data.find((branch) => branch.is_default);
				const selected =
					storedBranch || (defaultBranch ? defaultBranch.branch_id : temp[0].value);
				setbranch((pre) => ({ ...pre, data: selected }));

				setCurrentPage(1);
				setHasMore(true);
				if (controllerRef.current) controllerRef.current.abort();
				controllerRef.current = new AbortController();
				fetchServices(selected, 1, perPage, undefined, controllerRef.current.signal);
				fetchSlider(selected);

				localStorage.setItem('branches-list', JSON.stringify(temp));
				localStorage.setItem('selectedBranch', selected);

				let isReload = false;
				try {
					const navEntries = performance.getEntriesByType
						? performance.getEntriesByType('navigation')
						: null;
					if (navEntries && navEntries.length > 0) {
						isReload = navEntries[0].type === 'reload';
					} else if (performance && performance.navigation) {
						isReload = performance.navigation.type === 1;
					}
				} catch (e) {
					isReload = false;
				}
				let preserveCache = false;
				try {
					const cache = JSON.parse(sessionStorage.getItem('home-cache'));
					if (cache && cache.fromDetail && cache.savedAt) {
						const age = Date.now() - cache.savedAt;
						const TTL = 5 * 1000;
						if (age <= TTL) {
							preserveCache = true;
						}
					}
					if (isReload && !preserveCache) {
						sessionStorage.removeItem('home-cache');
						setActiveTab('services');
						setTotalRowsServices(null);
						setTotalRowsProducts(null);
						settotalRows(0);
						setData([]);
						setProducts([]);
					}
					if (cache && cache.branch === selected) {
						if (cache.activeTab) setActiveTab(cache.activeTab);
						if (cache.data) setData(cache.data);
						if (cache.products) setProducts(cache.products);
						if (typeof cache.totalRowsServices !== 'undefined')
							setTotalRowsServices(cache.totalRowsServices);
						if (typeof cache.totalRowsProducts !== 'undefined')
							setTotalRowsProducts(cache.totalRowsProducts);
						if (cache.perPage) setPerPage(cache.perPage);
						if (cache.currentPage) setCurrentPage(cache.currentPage);
						if (cache.totalRows) settotalRows(cache.totalRows);

						if (cache.selectedId) {
							setTimeout(() => {
								const el = document.getElementById(`home-item-${cache.selectedId}`);
								if (el && el.scrollIntoView) {
									el.scrollIntoView({ behavior: 'smooth', block: 'center' });
								}
							}, 100);
						}
					}
				} catch (err) {}
			} else {
				localStorage.removeItem('branches-list');
			}
		};

		const storedBranch = localStorage.getItem('selectedBranch');

		fetchata();
	}, []);

	const handleBranchChange = (e) => {
		sessionStorage.removeItem('home-cache');
		if (branch.error) {
			setbranch((pre) => ({ ...pre, error: false }));
		}

		setbranch((pre) => ({
			...pre,
			data: e.target.value,
		}));

		// Avoid immediate double-trigger from observer when list resets
		isFirstLoadRef.current = true;

		if (activeTab === 'services') {
			fetchServices(e.target.value);
			fetchSlider(e.target.value);
		} else {
			fetchProductsWL(e.target.value);
		}

		localStorage.setItem('selectedBranch', e.target.value);

		const branchesList = JSON.parse(localStorage.getItem('branches-list'));

		const selectedBranchName = branchesList?.find(
			(branch) => String(branch.value) === String(e.target.value),
		)?.text;

		window.dispatchEvent(
			new CustomEvent('branchChanged', {
				detail: { name: selectedBranchName },
			}),
		);
	};

	const { setIsOpen } = useTour();

	useEffect(() => {
		const timeout = setTimeout(() => setIsOpen(true), 3000);
		return () => {
			clearTimeout(timeout);
		};
	}, []);

	// NOTE: category changes should NOT auto-fetch; only apply on "Filter Now".

	const fetchServices = async (
		branchId,
		page = 1,
		limit = perPage,
		searchVal = searchValue,
		signal = undefined,
	) => {
		const item = {
			action: 'services_list_wl',
			branch_id: branchId,
			page_id: page,
			limit: limit,
			search_value: searchVal,
		};
		try {
			if (page <= 1) {
				// Reset first-page loaded flag at the start of initial load
				hasLoadedFirstPageRef.current = false;
				setIsListLoading(true);
			}
			const flechdata = await apiServicewt(item, navigate, { signal });
			if (flechdata.data) {
				// Initialize bounds from backend for services (these are the true available bounds)
				if (page <= 1) {
					const apiMin = Math.floor(Number(flechdata?.min_amount || 0));
					const apiMax = Math.ceil(Number(flechdata?.max_amount || 1000));
					setSliderMinAvailable(apiMin);
					setSliderMaxAvailable(apiMax);
					setServicesBoundsLoaded(true);
					// If user hasn't selected a range yet for services, seed it from API
					setMinprice((prev) => {
						const shouldInit =
							servicesRange === null &&
							activeTab === 'services' &&
							(prev === null ||
								typeof prev === 'undefined' ||
								prev === '' ||
								prev === 0);
						return shouldInit ? apiMin : prev;
					});
					setMaxprice((prev) => {
						const shouldInit =
							servicesRange === null &&
							activeTab === 'services' &&
							(prev === null ||
								typeof prev === 'undefined' ||
								prev === '' ||
								prev === 100);
						return shouldInit ? apiMax : prev;
					});
				}
				// setSliderMinAvailable(Math.floor(flechdata?.min_amount || 0).toString());
				// setSliderMaxAvailable(Math.floor(flechdata?.max_amount ? flechdata.max_amount - 100 : 1000).toString());
				if (page > 1) {
					setData((prev) => [...prev, ...flechdata.data]);
				} else {
					setData(flechdata.data);
				}
				setScurrency(flechdata.currency);
			}

			if (flechdata.TotalRecords || flechdata.TotalRecords === 0) {
				setTotalRowsServices(flechdata.TotalRecords);
				if (activeTab === 'services') settotalRows(flechdata.TotalRecords);
				const currentCount =
					(page - 1) * limit + (flechdata.data ? flechdata.data.length : 0);

				if (flechdata.data && flechdata.data.length > 0) {
					setHasMore(
						currentCount < Number(flechdata.TotalRecords) &&
							flechdata.data.length === limit,
					);
				} else {
					setHasMore(false);
				}
			} else {
				setTotalRowsServices(0);
				if (activeTab === 'services') settotalRows(0);
				setHasMore(false);
			}
		} catch (error) {
			console.error('Error fetching services:', error);
		} finally {
			if (page <= 1) {
				setIsListLoading(false);
				// Mark that the first page has fully finished loading
				hasLoadedFirstPageRef.current = true;
			}
		}
	};

	const fetchSlider = async (branchId) => {
		const item = { action: 'slider_list', branch_id: branchId };
		try {
			const flechdata = await apiServicewt(item, navigate);
			if (Array.isArray(flechdata.data)) {
				if (flechdata.data.length > 0) {
					setVslider(flechdata.data);
				} else {
					setVslider(null);
				}
			}
		} catch (error) {
			setVslider(null);
		}
	};

	const fetchProductsWL = async (
		branchId,
		page = 1,
		limit = perPage,
		searchVal = '',
		signal = undefined,
	) => {
		const item = {
			action: 'get_product_list_wl',
			branch_id: branchId,
			page_id: page,
			limit: limit,
			search_value: searchVal,
		};
		try {
			if (page <= 1) {
				// Reset first-page loaded flag at the start of initial load
				hasLoadedFirstPageRef.current = false;
				setIsListLoading(true);
			}
			const flechdata = await apiServicewt(item, navigate, { signal });
			// Initialize PRODUCTS bounds from backend on first page.
			// These are the available bounds for products filtering.
			if (page <= 1) {
				const apiMin = Math.floor(Number(flechdata?.min_amount || 0));
				const apiMax = Math.ceil(Number(flechdata?.max_amount || 1000));
				setProductsMinAvailable(apiMin);
				setProductsMaxAvailable(apiMax);
				setProductsBoundsLoaded(true);
				// If user hasn't picked a products range yet AND is on products tab, seed applied values.
				setMinprice((prev) => {
					const shouldInit =
						productsRange === null &&
						activeTab === 'products' &&
						(prev === null || typeof prev === 'undefined' || prev === '' || prev === 0);
					return shouldInit ? apiMin : prev;
				});
				setMaxprice((prev) => {
					const shouldInit =
						productsRange === null &&
						activeTab === 'products' &&
						(prev === null ||
							typeof prev === 'undefined' ||
							prev === '' ||
							prev === 100);
					return shouldInit ? apiMax : prev;
				});
			}
			if (flechdata.data) {
				if (page > 1) {
					setProducts((prev) => [...prev, ...flechdata.data]);
				} else {
					setProducts(flechdata.data);
				}
			}
			let total = 0;
			if (flechdata.TotalRecords || flechdata.TotalRecords === 0) {
				total = flechdata.TotalRecords;
				setTotalRowsProducts(flechdata.TotalRecords);
				if (activeTab === 'products') settotalRows(flechdata.TotalRecords);
				const currentCount =
					(page - 1) * limit + (flechdata.data ? flechdata.data.length : 0);

				if (flechdata.data && flechdata.data.length > 0) {
					setHasMore(
						currentCount < Number(flechdata.TotalRecords) &&
							flechdata.data.length === limit,
					);
				} else {
					setHasMore(false);
				}
			} else {
				setTotalRowsProducts(0);
				if (activeTab === 'products') settotalRows(0);
				setHasMore(false);
			}
			return total;
		} catch (error) {
			console.error('Error fetching products:', error);
		} finally {
			if (page <= 1) {
				setIsListLoading(false);
				// Mark that the first page has fully finished loading
				hasLoadedFirstPageRef.current = true;
			}
		}
	};

	const filterProductsWL = async (
		branchId,
		page = 1,
		limit = perPage,
		searchVal = '',
		signal = undefined,
		explicitMinPrice = undefined,
		explicitMaxPrice = undefined,
	) => {
		const minToUse =
			explicitMinPrice === null || typeof explicitMinPrice === 'undefined'
				? minprice
				: explicitMinPrice;
		const maxToUse =
			explicitMaxPrice === null || typeof explicitMaxPrice === 'undefined'
				? maxprice
				: explicitMaxPrice;
		const item = {
			action: 'get_product_list_wl',
			branch_id: branchId,
			page_id: page,
			limit: limit,
			search_value: searchVal,
			// Don't use `|| '0'` here because valid values like 0 become falsy and get replaced.
			min_price: String(Number.isFinite(Number(minToUse)) ? Number(minToUse) : 0),
			max_price: String(Number.isFinite(Number(maxToUse)) ? Number(maxToUse) : 0),
		};
		try {
			if (page <= 1) {
				hasLoadedFirstPageRef.current = false;
				setIsListLoading(true);
			}
			const flechdata = await apiServicewt(item, navigate, { signal });
			if (flechdata.data) {
				if (page > 1) {
					setProducts((prev) => [...prev, ...flechdata.data]);
				} else {
					setProducts(flechdata.data);
				}
			}
			let total = 0;
			if (flechdata.TotalRecords || flechdata.TotalRecords === 0) {
				total = flechdata.TotalRecords;
				setTotalRowsProducts(flechdata.TotalRecords);
				if (activeTab === 'products') settotalRows(flechdata.TotalRecords);
				const currentCount =
					(page - 1) * limit + (flechdata.data ? flechdata.data.length : 0);

				if (flechdata.data && flechdata.data.length > 0) {
					setHasMore(
						currentCount < Number(flechdata.TotalRecords) &&
							flechdata.data.length === limit,
					);
				} else {
					setHasMore(false);
				}
			} else {
				setTotalRowsProducts(0);
				if (activeTab === 'products') settotalRows(0);
				setHasMore(false);
			}
			return total;
		} catch (error) {
			console.error('Error filtering products:', error);
		} finally {
			if (page <= 1) {
				setIsListLoading(false);
				hasLoadedFirstPageRef.current = true;
			}
		}
	};

	const catfilterapp = async (branchId, page = 1, limit = perPage, signal = undefined) => {
		const categoryParam = Array.isArray(catid) ? catid.join(',') : '';
		const item = {
			action: 'services_list_wl',
			branch_id: branchId,
			page_id: page,
			limit: limit,
			category_id: categoryParam,
			// IMPORTANT: send applied user filters, not the available API bounds.
			min_price: String(Number.isFinite(Number(minprice)) ? Number(minprice) : 0),
			max_price: String(Number.isFinite(Number(maxprice)) ? Number(maxprice) : 0),
		};
		try {
			//
			if (page <= 1) {
				// Reset first-page loaded flag at the start of initial load
				hasLoadedFirstPageRef.current = false;
				setIsListLoading(true);
			}
			const flechdata = await apiServicewt(item, navigate, { signal });

			//setCatid(null);
			if (page <= 1) {
				setSliderMaxAvailable(Math.ceil(flechdata?.max_amount || 1000));
				setSliderMinAvailable(Math.floor(flechdata?.min_amount || 0));
				setMinprice((prev) =>
					prev === null || typeof prev === 'undefined' || prev === ''
						? Math.floor(flechdata?.min_amount || 0)
						: prev,
				);
				setMaxprice((prev) =>
					prev === null || typeof prev === 'undefined' || prev === ''
						? Math.floor(flechdata?.max_amount || 100)
						: prev,
				);
			}

			//  setSliderMinAvailable(Math.floor(flechdata?.min_amount || 0).toString());
			//  setSliderMaxAvailable(Math.floor(flechdata?.max_amount ? flechdata.max_amount - 100 : 1000).toString());
			if (flechdata.data) {
				if (page > 1) {
					setData((prev) => [...prev, ...flechdata.data]);
				} else {
					setData(flechdata.data);
				}
				setScurrency(flechdata.currency);
			}

			if (flechdata.TotalRecords || flechdata.TotalRecords === 0) {
				setTotalRowsServices(flechdata.TotalRecords);
				if (activeTab === 'services') settotalRows(flechdata.TotalRecords);
				const currentCount =
					(page - 1) * limit + (flechdata.data ? flechdata.data.length : 0);

				if (flechdata.data && flechdata.data.length > 0) {
					setHasMore(
						currentCount < Number(flechdata.TotalRecords) &&
							flechdata.data.length === limit,
					);
				} else {
					setHasMore(false);
				}
			} else {
				setTotalRowsServices(0);
				if (activeTab === 'services') settotalRows(0);
				setHasMore(false);
			}
		} catch (error) {
			console.error('Error fetching services:', error);
		} finally {
			if (page <= 1) {
				setIsListLoading(false);
				// Mark that the first page has fully finished loading
				hasLoadedFirstPageRef.current = true;
			}
		}
	};
	const filterapp = async (
		branchId,
		page = 1,
		limit = perPage,
		signal = undefined,
		explicitMinPrice = undefined,
		explicitMaxPrice = undefined,
		explicitCatIds = undefined,
	) => {
		const catIdsToUse =
			explicitCatIds === null || typeof explicitCatIds === 'undefined'
				? catid
				: explicitCatIds;
		const categoryParam = Array.isArray(catIdsToUse) ? catIdsToUse.join(',') : '';
		const minToUse =
			explicitMinPrice === null || typeof explicitMinPrice === 'undefined'
				? minprice
				: explicitMinPrice;
		const maxToUse =
			explicitMaxPrice === null || typeof explicitMaxPrice === 'undefined'
				? maxprice
				: explicitMaxPrice;
		const item = {
			action: 'services_list_wl',
			branch_id: branchId,
			page_id: page,
			limit: limit,
			category_id: categoryParam,
			// Don't use `|| '0'` here because valid values like 0 become falsy and get replaced.
			min_price: String(Number.isFinite(Number(minToUse)) ? Number(minToUse) : 0),
			max_price: String(Number.isFinite(Number(maxToUse)) ? Number(maxToUse) : 0),
		};
		try {
			//
			if (page <= 1) {
				// Reset first-page loaded flag at the start of initial load
				hasLoadedFirstPageRef.current = false;
				setIsListLoading(true);
			}
			const flechdata = await apiServicewt(item, navigate, { signal });

			//setCatid(null);
			// 	setMinprice(Math.floor(flechdata?.min_amount || 0).toString());
			// setMaxprice(Math.floor(flechdata?.max_amount || 0).toString());
			//  setSliderMinAvailable(Math.floor(flechdata?.min_amount || 0).toString());
			//  setSliderMaxAvailable(Math.floor(flechdata?.max_amount ? flechdata.max_amount - 100 : 1000).toString());
			if (flechdata.data) {
				if (page > 1) {
					setData((prev) => [...prev, ...flechdata.data]);
				} else {
					setData(flechdata.data);
				}
				setScurrency(flechdata.currency);
			}

			if (flechdata.TotalRecords || flechdata.TotalRecords === 0) {
				setTotalRowsServices(flechdata.TotalRecords);
				if (activeTab === 'services') settotalRows(flechdata.TotalRecords);
				const currentCount =
					(page - 1) * limit + (flechdata.data ? flechdata.data.length : 0);

				if (flechdata.data && flechdata.data.length > 0) {
					setHasMore(
						currentCount < Number(flechdata.TotalRecords) &&
							flechdata.data.length === limit,
					);
				} else {
					setHasMore(false);
				}
			} else {
				setTotalRowsServices(0);
				if (activeTab === 'services') settotalRows(0);
				setHasMore(false);
			}
		} catch (error) {
			console.error('Error fetching services:', error);
		} finally {
			if (page <= 1) {
				setIsListLoading(false);
				// Mark that the first page has fully finished loading
				hasLoadedFirstPageRef.current = true;
			}
		}
	};
	function handleRemove(id) {
		const newData = data.filter((item) => item.id !== id);
		setData(newData);
	}

	function handleEdit(id) {
		const newData = data.filter((item) => item.id === id);
		setEditItem(newData[0]);
	}

	const handlefunction = (pagenumber, limit, searchVal) => {
		const pagelimit = limit || perPage;
		if (!hasMore && pagenumber > 1) return;

		let branchIdToUse = branch?.data;
		if (!branchIdToUse) {
			branchIdToUse =
				localStorage.getItem('selectedBranch') ||
				(branches && branches[0] && branches[0].value);
		}
		if (!branchIdToUse) {
			setHasMore(false);
			return;
		}

		if (controllerRef.current) controllerRef.current.abort();
		controllerRef.current = new AbortController();
		const signal = controllerRef.current.signal;
		if (activeTab === 'services') {
			setIsLoadingMore(true);
			// Keep pagination respecting applied filters
			const effectiveSearch = searchVal !== undefined ? searchVal : searchValue;
			const hasServiceFilters =
				(Array.isArray(catid) && catid.length > 0) ||
				Number(minprice) !== Number(sliderMinAvailable) ||
				Number(maxprice) !== Number(sliderMaxAvailable);
			const request = hasServiceFilters
				? filterapp(branchIdToUse, pagenumber, pagelimit, signal, minprice, maxprice, catid)
				: fetchServices(branchIdToUse, pagenumber, pagelimit, effectiveSearch, signal);
			return Promise.resolve(request).finally(() => setIsLoadingMore(false));
		} else {
			setIsLoadingMore(true);
			// Keep pagination respecting applied PRODUCTS filters
			const effectiveSearch = searchVal !== undefined ? searchVal : searchValue;
			const productBoundsMin = Number(productsMinAvailable);
			const productBoundsMax = Number(productsMaxAvailable);
			// IMPORTANT:
			// minprice/maxprice are shared across tabs and can be updated by services-bounds responses;
			// for products pagination we must use the last APPLIED products range.
			const appliedProdMin = Number(
				productsRangeRef.current?.min ?? productsRange?.min ?? minprice,
			);
			const appliedProdMax = Number(
				productsRangeRef.current?.max ?? productsRange?.max ?? maxprice,
			);
			const hasProductFilters =
				Number(appliedProdMin) !== productBoundsMin ||
				Number(appliedProdMax) !== productBoundsMax;
			const request = hasProductFilters
				? filterProductsWL(
						branchIdToUse,
						pagenumber,
						pagelimit,
						effectiveSearch,
						signal,
						appliedProdMin,
						appliedProdMax,
				  )
				: fetchProductsWL(branchIdToUse, pagenumber, pagelimit, effectiveSearch, signal);
			return Promise.resolve(request).finally(() => setIsLoadingMore(false));
		}
	};

	// Clear all filters when switching between Services and Products.
	// This avoids cross-tab state bleed and ensures switching tabs doesn't count as a filter update.
	useEffect(() => {
		// Close the filter drawer so drafts don't leak visually across tabs.
		setShowFilters(false);
		// Reset categories (services-only)
		setCatid([]);
		setDraftCatIds([]);

		if (activeTab === 'products') {
			const resetMin = Number(productsMinAvailable);
			const resetMax = Number(productsMaxAvailable);
			setMinprice(resetMin);
			setMaxprice(resetMax);
			setDraftMinprice(resetMin);
			setDraftMaxprice(resetMax);
			setProductsRange(null);
		} else {
			const resetMin = Number(sliderMinAvailable);
			const resetMax = Number(sliderMaxAvailable);
			setMinprice(resetMin);
			setMaxprice(resetMax);
			setDraftMinprice(resetMin);
			setDraftMaxprice(resetMax);
			setServicesRange(null);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab]);

	const cancelSmoothScroll = () => {
		try {
			if (scrollAnimRef.current.rafId) {
				cancelAnimationFrame(scrollAnimRef.current.rafId);
				scrollAnimRef.current.rafId = null;
			}

			if (scrollAnimRef.current.cancelHandler) {
				window.removeEventListener('wheel', scrollAnimRef.current.cancelHandler);
				window.removeEventListener('touchstart', scrollAnimRef.current.cancelHandler);
				window.removeEventListener('keydown', scrollAnimRef.current.cancelHandler);
				scrollAnimRef.current.cancelHandler = null;
			}
		} catch (e) {}
	};

	const smoothScrollToTop = (duration = 600) => {
		cancelSmoothScroll();
		const startY = window.scrollY || window.pageYOffset || 0;
		if (startY === 0) return;
		const startTime = performance.now();

		const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

		const animate = (now) => {
			const elapsed = now - startTime;
			const t = Math.min(1, elapsed / duration);
			const eased = easeOutCubic(t);
			const currentY = Math.round(startY * (1 - eased));
			window.scrollTo(0, currentY);
			if (t < 1) {
				scrollAnimRef.current.rafId = requestAnimationFrame(animate);
			} else {
				scrollAnimRef.current.rafId = null;
			}
		};

		const cancelHandler = () => cancelSmoothScroll();
		scrollAnimRef.current.cancelHandler = cancelHandler;
		window.addEventListener('wheel', cancelHandler, { passive: true });
		window.addEventListener('touchstart', cancelHandler, { passive: true });
		window.addEventListener('keydown', cancelHandler, { passive: true });

		scrollAnimRef.current.rafId = requestAnimationFrame(animate);
	};

	useEffect(() => {
		return () => {
			cancelSmoothScroll();
		};
	}, []);

	const formik = useFormik({
		initialValues: {
			name: '',
			price: '',
			stock: '',
			category: '',
		},
		onSubmit: (values) => {
			setEditPanel(false);
		},
	});

	useEffect(() => {
		if (editItem) {
			formik.setValues({
				name: editItem.name,
				price: editItem.price,
				stock: editItem.stock,
				category: editItem.category,
			});
		}
		return () => {
			formik.setValues({
				name: '',
				price: '',
				stock: '',
				category: '',
			});
		};
	}, [editItem]);

	const images = [
		{ id: 'Pic', img: Pic },
		{ id: 'Pic2', img: Pic2 },
		{ id: 'Pic3', img: Pic3 },
		{ id: 'Pic4', img: Pic4 },
		{ id: 'Pic5', img: Pic5 },
		{ id: 'Pic6', img: Pic6 },
		{ id: 'Pic7', img: Pic7 },
		{ id: 'Pic8', img: Pic8 },
	];

	const _gallery = (
		<div className='row g-4'>
			{images.map((item, index) => (
				<div key={item.id} className='col-xxl-2 col-lg-3 col-md-6'>
					<button
						type='button'
						onClick={() => setSelectedImage(item.img)}
						className={classNames(
							'ratio ratio-1x1',
							'rounded-2',
							'border-0',
							`bg-l${darkModeStatus ? 'o25' : '25'}-${colors[index % 7]}`,
							`bg-l${darkModeStatus ? 'o50' : '10'}-${colors[index % 7]}-hover`,
						)}>
						<img
							src={item.img}
							alt={item.id}
							width='100%'
							height='auto'
							className='object-fit-contain p-4'
						/>
					</button>
				</div>
			))}
		</div>
	);

	const SecondLayout = ({ d, i }) => {
		const rawSlideUrl = d.url || '';
		const trimmedSlideUrl = String(rawSlideUrl).trim();
		const isUrlPresent = Boolean(trimmedSlideUrl);
		const isClearlyUnsafe =
			/^\s*#/.test(trimmedSlideUrl) || /^javascript:/i.test(trimmedSlideUrl);
		let slideHref = '';
		const hasValidUrl = isUrlPresent && !isClearlyUnsafe;
		if (hasValidUrl) {
			try {
				let urlCandidate = trimmedSlideUrl;
				const siteDomain = window.location.origin;
				if (urlCandidate.startsWith(siteDomain)) {
					urlCandidate = urlCandidate.slice(siteDomain.length);
					if (urlCandidate.startsWith('/')) urlCandidate = urlCandidate.slice(1);
				}
				if (!/^https?:\/\//i.test(urlCandidate)) {
					urlCandidate = 'https://' + urlCandidate;
				}
				slideHref = urlCandidate;
			} catch (e) {
				slideHref = trimmedSlideUrl;
			}
		}

		const isMobileView = windowWidth <= 576;
		const isTabletView = windowWidth > 576 && windowWidth <= 992;

		const pick = (obj, keys) => {
			for (const k of keys) {
				if (!obj) continue;
				const v = obj[k];
				if (v && typeof v === 'string' && v.trim() !== '') return v;
			}
			return null;
		};

		const desktopKeys = ['slider_img'];
		const mobileKeys = ['mob_slider_img'];
		const tabletKeys = ['tab_slider_img'];

		const desktopImgRaw = pick(d, desktopKeys);
		const mobileImgRaw = pick(d, mobileKeys);
		const tabletImgRaw = pick(d, tabletKeys);

		const desktopImg = desktopImgRaw;
		const mobileImg = mobileImgRaw || desktopImgRaw;
		const tabletImg = tabletImgRaw || desktopImgRaw;

		let chosenRaw = desktopImg;
		if (isMobileView) chosenRaw = mobileImg || desktopImg;
		else if (isTabletView) chosenRaw = tabletImg || desktopImg;

		const resolvePossibleJson = (val) => {
			if (!val || typeof val !== 'string') return val;
			try {
				const parsed = JSON.parse(val);
				if (Array.isArray(parsed) && parsed.length > 0) return parsed[0];
				if (typeof parsed === 'string' && parsed.trim() !== '') return parsed;
				return val;
			} catch (e) {
				return val;
			}
		};

		const resolvedDesktop = resolvePossibleJson(desktopImg);
		const resolvedMobile = resolvePossibleJson(mobileImgRaw);
		const resolvedTablet = resolvePossibleJson(tabletImgRaw);
		const resolvedChosen = resolvePossibleJson(chosenRaw) || resolvedDesktop || '';

		const hasDesktopSpecific = Boolean(resolvedDesktop);
		const hasMobileSpecific = Boolean(resolvedMobile);
		const hasTabletSpecific = Boolean(resolvedTablet);

		const shouldAnimate =
			(isMobileView && hasMobileSpecific) ||
			(isTabletView && hasTabletSpecific) ||
			(!isMobileView && !isTabletView && hasDesktopSpecific);

		const SlideImage = ({ src, alt, doAnimate }) => {
			const [current, setCurrent] = useState(src);
			const [prev, setPrev] = useState(null);

			useEffect(() => {
				if (src === current) return;
				if (doAnimate && current) {
					setPrev(current);
					setCurrent(src);
					const id = setTimeout(() => setPrev(null), 480);
					return () => clearTimeout(id);
				} else {
					setPrev(null);
					setCurrent(src);
				}
			}, [src, doAnimate]);

			if (!current)
				return <div style={{ width: '100%', height: '100%', background: '#eee' }} />;

			return (
				<div
					style={{
						width: '100%',
						height: '100%',
						position: 'relative',
						overflow: 'hidden',
					}}>
					{prev && (
						<motion.img
							src={prev}
							alt={alt}
							initial={{ opacity: 1 }}
							animate={{ opacity: 0 }}
							transition={{ duration: 0.45, ease: 'easeInOut' }}
							style={{
								position: 'absolute',
								inset: 0,
								width: '100%',
								height: '100%',
								objectFit: 'cover',
							}}
						/>
					)}
					<motion.img
						src={current}
						alt={alt}
						initial={{ opacity: prev ? 0 : 1, y: prev ? 8 : 0 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.45, ease: 'easeInOut' }}
						style={{
							position: 'absolute',
							inset: 0,
							width: '100%',
							height: '100%',
							objectFit: 'cover',
						}}
					/>
				</div>
			);
		};

		return (
			<CarouselSlide key={i}>
				{hasValidUrl ? (
					<a href={slideHref} target='_blank' rel='noopener noreferrer'>
						<div key={i} className='carousel-slide-bg csl-slide'>
							<SlideImage
								src={resolvedChosen}
								alt={d.title || `slide-${i}`}
								doAnimate={shouldAnimate}
							/>
						</div>
					</a>
				) : (
					<div
						key={i}
						className='carousel-slide-bg csl-slide'
						style={{ cursor: 'default' }}>
						<SlideImage
							src={resolvedChosen}
							alt={d.title || `slide-${i}`}
							doAnimate={shouldAnimate}
						/>
					</div>
				)}
			</CarouselSlide>
		);
	};

	const defaultUrl = 'www.schedulerdesk.com';
	const rawUrl = sitename.website_url || '';
	let displayUrl = rawUrl || defaultUrl;
	let linkURL = displayUrl;
	if (linkURL && !linkURL.match(/^(http|https|ftp):\/\//i)) {
		linkURL = `https://${linkURL}`;
	}

	const showNoServices = !isListLoading && totalRowsServices === 0;
	const showNoProducts = !isListLoading && totalRowsProducts === 0;

	// Slider available range for SERVICES (derived from backend min/max)
	const [sliderMinAvailable, setSliderMinAvailable] = useState(0);
	const [sliderMaxAvailable, setSliderMaxAvailable] = useState(100000);

	// When API bounds arrive for the currently visible tab, immediately sync applied + draft
	// ranges — but only if the user hasn't applied a custom range for that tab.
	useEffect(() => {
		if (activeTab !== 'services') return;
		if (!servicesBoundsLoaded) return;
		if (servicesRange !== null) return; // user already picked a range

		const boundsMin = Number(sliderMinAvailable);
		const boundsMax = Number(sliderMaxAvailable);
		setMinprice(boundsMin);
		setMaxprice(boundsMax);
		if (!editingMinRef.current) setDraftMinprice(boundsMin);
		if (!editingMaxRef.current) setDraftMaxprice(boundsMax);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab, servicesBoundsLoaded, sliderMinAvailable, sliderMaxAvailable]);

	useEffect(() => {
		if (activeTab !== 'products') return;
		if (!productsBoundsLoaded) return;
		if (productsRange !== null) return; // user already picked a range

		const boundsMin = Number(productsMinAvailable);
		const boundsMax = Number(productsMaxAvailable);
		setMinprice(boundsMin);
		setMaxprice(boundsMax);
		if (!editingMinRef.current) setDraftMinprice(boundsMin);
		if (!editingMaxRef.current) setDraftMaxprice(boundsMax);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab, productsBoundsLoaded, productsMinAvailable, productsMaxAvailable]);

	// NOTE: we intentionally do NOT have a separate "restore range on tab switch" effect.
	// Filters are cleared immediately in the [activeTab] effect above, and bounds are seeded
	// by fetchServices/fetchProductsWL on first-page load.

	// useEffect(() => {
	// 	const prices = (data || []).map((d) => Number(d.price)).filter((n) => !isNaN(n));
	// 	if (prices.length > 0) {
	// 		const lo = Math.min(...prices);
	// 		const hi = Math.max(...prices);
	// 		setSliderMinAvailable(Math.floor(lo));
	// 		setSliderMaxAvailable(Math.ceil(maxpriceamount));
	// 		// If user hasn't set values yet, initialize them to available bounds
	// 		// if (minprice === null || minprice === undefined) setMinprice(Math.floor(lo));
	// 		// if (maxprice === null || maxprice === undefined) setMaxprice(Math.ceil(hi));
	// 	} else {
	// 		setSliderMinAvailable(0);
	// 		setSliderMaxAvailable(1000);
	// 	}
	// }, [data]);

	const formatLKR = (value) => `LKR ${Number(value).toLocaleString('en-LK')}`;

	// Small range slider (double thumb) component
	// const RangeSlider = ({ min = 0, max = 1000, lower, upper, onChange }) => {
	// 	const minGap = 1;
	// 	const handleLowerChange = (val) => {
	// 		const v = Math.min(Number(val), Number(upper) - minGap);
	// 		onChange && onChange({ lower: v, upper: Number(upper) });
	// 	};
	// 	const handleUpperChange = (val) => {
	// 		const v = Math.max(Number(val), Number(lower) + minGap);
	// 		onChange && onChange({ lower: Number(lower), upper: v });
	// 	};

	// 	return (
	// 		<div className="range-slider-wrapper">
	// 			<div className="slider-inputs">
	// 				<input type="range" min={min} max={max} value={lower} onChange={(e) => handleLowerChange(e.target.value)} />
	// 				<input type="range" min={min} max={max} value={upper} onChange={(e) => handleUpperChange(e.target.value)} />
	// 			</div>
	// 			<div className="slider-values d-flex align-items-center" style={{ gap: 8, marginTop: 6 }}>
	// 				<Input type="number" value={lower} onChange={(e) => handleLowerChange(e.target.value)} />
	// 				<span>-</span>
	// 				<Input type="number" value={upper} onChange={(e) => handleUpperChange(e.target.value)} />
	// 			</div>
	// 		</div>
	// 	);
	// };

	const MuiRangeSlider = ({ min, max, lower, upper, onChange }) => {
		const safeMin = Number.isFinite(Number(min)) ? Number(min) : 0;
		const safeMax = Number.isFinite(Number(max)) ? Number(max) : safeMin;
		const range = Math.max(0, safeMax - safeMin);

		// Keep thumbs within bounds and ordered
		const safeLower = clampPrice(lower, safeMin, safeMax);
		const safeUpper = clampPrice(upper, safeMin, safeMax);
		const orderedLower = safeLower === '' ? safeMin : Number(safeLower);
		const orderedUpper = safeUpper === '' ? safeMax : Number(safeUpper);
		const value = [Math.min(orderedLower, orderedUpper), Math.max(orderedLower, orderedUpper)];

		// Dynamic step calculation
		const step = range <= 0 ? 1 : Math.max(1, Math.round(range / 200));

		// Local state for smooth dragging
		const [localValue, setLocalValue] = useState(value);

		// Sync local value with props when they change
		useEffect(() => {
			setLocalValue(value);
		}, [lower, upper]);

		// Handle drag changes (smooth updates)
		const handleChange = (_, newValue) => {
			if (!Array.isArray(newValue)) return;
			setLocalValue(newValue);
		};

		// Commit changes when dragging ends
		const handleChangeCommitted = (_, newValue) => {
			if (!Array.isArray(newValue)) return;
			// Ensure values are integers
			const roundedValues = newValue.map((v) => Math.round(v));
			onChange({ lower: roundedValues[0], upper: roundedValues[1] });
		};

		return (
			<Box sx={{ width: '100%', px: 1 }}>
				<Slider
					value={localValue}
					min={safeMin}
					max={safeMax}
					step={step}
					disableSwap
					valueLabelDisplay='auto'
					valueLabelFormat={(v) => formatLKR(v)}
					onChange={handleChange}
					onChangeCommitted={handleChangeCommitted}
					sx={{
						color: '#6c5dd3',
						height: 6,
						'& .MuiSlider-rail': {
							opacity: 0.25,
							backgroundColor: darkModeStatus ? '#555' : '#ddd',
						},
						'& .MuiSlider-track': {
							background: 'linear-gradient(90deg,#6c5dd3 0%,#9b74ff 100%)',
							border: 'none',
						},
						'& .MuiSlider-thumb': {
							width: 20,
							height: 20,
							backgroundColor: '#fff',
							border: '3px solid #6c5dd3',
							boxShadow: '0 6px 18px rgba(108,93,211,0.25)',
							'&:hover, &.Mui-focusVisible': {
								boxShadow: '0 0 0 8px rgba(108,93,211,0.16)',
							},
							'&.Mui-active': {
								boxShadow: '0 0 0 12px rgba(108,93,211,0.16)',
							},
						},
					}}
				/>
			</Box>
		);
	};

	const clampPrice = (val, min, max) => {
		// Allow empty string / cleared inputs to pass through as empty so the
		// UI can show a blank field. Callers that need numeric values should
		// handle the empty-string case (the slider code already does).
		if (val === '' || val === null || typeof val === 'undefined') return '';
		const n = Number(val);
		if (Number.isNaN(n)) return '';
		return Math.min(max, Math.max(min, n));
	};

	const formatCurrencyShort = (value) => {
		const n = Number(value);
		if (Number.isNaN(n)) return '';
		return `LKR ${n.toLocaleString('en-LK')}`;
	};

	// Right-side filter drawer (hidden by default)
	const filterDrawerWidth = isMobile ? '92vw' : 380;

	// Tab-aware price bounds for the filter UI
	const priceBoundsMin =
		activeTab === 'products' ? Number(productsMinAvailable) : Number(sliderMinAvailable);
	const priceBoundsMax =
		activeTab === 'products' ? Number(productsMaxAvailable) : Number(sliderMaxAvailable);

	// Whether the API-provided bounds for the currently visible tab have arrived.
	const priceBoundsLoaded =
		activeTab === 'products' ? productsBoundsLoaded : servicesBoundsLoaded;

	// Draft filters (edited inside panel; applied only on "Filter Now")
	const [draftMinprice, setDraftMinprice] = useState(minprice);
	const [draftMaxprice, setDraftMaxprice] = useState(maxprice);
	const [draftCatIds, setDraftCatIds] = useState(catid);

	// UI validation: disable "Filter" action when price inputs are empty/invalid
	const arePriceInputsValid = () => {
		const a = draftMinprice;
		const b = draftMaxprice;
		if (a === '' || a === null || typeof a === 'undefined') return false;
		if (b === '' || b === null || typeof b === 'undefined') return false;
		const an = Number(a);
		const bn = Number(b);
		if (!Number.isFinite(an) || !Number.isFinite(bn)) return false;
		// Ensure ordering
		if (an > bn) return false;
		// Ensure within bounds
		const minBound = priceBoundsMin;
		const maxBound = priceBoundsMax;
		if (an < Number(minBound) || bn > Number(maxBound)) return false;
		return true;
	};

	// Refs to track whether the user is actively editing inputs so external
	// effects (bounds loading, panel open) don't stomp on their typing.
	const editingMinRef = useRef(false);
	const editingMaxRef = useRef(false);

	const handleMinFocus = () => {
		editingMinRef.current = true;
	};
	const handleMinBlur = () => {
		editingMinRef.current = false;
		// On blur, normalize the value: keep empty as empty, parse numeric and
		// clamp into bounds if necessary, otherwise clear invalid input.
		const v = draftMinprice;
		// If the field was left empty, restore the available minimum bound.
		if (v === '' || v === null || typeof v === 'undefined') {
			setDraftMinprice(priceBoundsMin);
			return;
		}
		const n = Number(v);
		if (Number.isNaN(n)) {
			setDraftMinprice('');
			return;
		}
		const clamped = Math.min(priceBoundsMax, Math.max(priceBoundsMin, Math.round(n)));
		setDraftMinprice(clamped);
	};

	const handleMaxFocus = () => {
		editingMaxRef.current = true;
	};
	const handleMaxBlur = () => {
		editingMaxRef.current = false;
		const v = draftMaxprice;
		// If the field was left empty, restore the available maximum bound.
		if (v === '' || v === null || typeof v === 'undefined') {
			setDraftMaxprice(priceBoundsMax);
			return;
		}
		const n = Number(v);
		if (Number.isNaN(n)) {
			setDraftMaxprice('');
			return;
		}
		const clamped = Math.min(priceBoundsMax, Math.max(priceBoundsMin, Math.round(n)));
		setDraftMaxprice(clamped);
	};

	useEffect(() => {
		// Keep draft values in sync with applied values when panel opens
		if (showFilters) {
			if (!editingMinRef.current) setDraftMinprice(minprice);
			if (!editingMaxRef.current) setDraftMaxprice(maxprice);
			setDraftCatIds(catid);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showFilters]);

	// Prevent background scrolling when the filter drawer is open
	useEffect(() => {
		if (showFilters) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}

		return () => {
			document.body.style.overflow = '';
		};
	}, [showFilters]);

	const getBranchId = () => {
		let branchIdToUse = branch?.data;
		if (!branchIdToUse) {
			branchIdToUse =
				localStorage.getItem('selectedBranch') ||
				(branches && branches[0] && branches[0].value);
		}
		return branchIdToUse;
	};

	const clearFilters = () => {
		const branchIdToUse = getBranchId();
		const resetMin =
			activeTab === 'products' ? Number(productsMinAvailable) : Number(sliderMinAvailable);
		const resetMax =
			activeTab === 'products' ? Number(productsMaxAvailable) : Number(sliderMaxAvailable);
		const resetCats = [];

		// Reset applied
		setCatid(resetCats);
		setMinprice(resetMin);
		setMaxprice(resetMax);
		if (activeTab === 'products') setProductsRange(null);
		else setServicesRange(null);

		// Reset draft (so the UI updates immediately if panel is open)
		setDraftCatIds(resetCats);
		setDraftMinprice(resetMin);
		setDraftMaxprice(resetMax);

		// Immediately refetch with cleared filters
		if (branchIdToUse) {
			setCurrentPage(1);
			setHasMore(true);
			if (activeTab === 'products') {
				setProducts([]);
				filterProductsWL(branchIdToUse, 1, perPage, '', undefined, resetMin, resetMax);
			} else {
				setData([]);
				filterapp(branchIdToUse, 1, perPage, undefined, resetMin, resetMax, resetCats);
			}
		}

		setShowFilters(false);
	};

	const hasActiveFilters = () => {
		const boundsMin =
			activeTab === 'products' ? Number(productsMinAvailable) : Number(sliderMinAvailable);
		const boundsMax =
			activeTab === 'products' ? Number(productsMaxAvailable) : Number(sliderMaxAvailable);
		const priceActive = Number(minprice) !== boundsMin || Number(maxprice) !== boundsMax;
		const categoryCount = activeTab === 'services' && Array.isArray(catid) ? catid.length : 0;
		return Boolean(priceActive || categoryCount > 0);
	};

	const activeFiltersCount = () => {
		let c = 0;
		const boundsMin =
			activeTab === 'products' ? Number(productsMinAvailable) : Number(sliderMinAvailable);
		const boundsMax =
			activeTab === 'products' ? Number(productsMaxAvailable) : Number(sliderMaxAvailable);
		if (Number(minprice) !== boundsMin || Number(maxprice) !== boundsMax) c += 1;
		if (activeTab === 'services' && Array.isArray(catid) && catid.length > 0) c += catid.length;
		return c;
	};

	const applyFilters = () => {
		const branchIdToUse = getBranchId();
		if (!branchIdToUse) return;

		const boundsMin =
			activeTab === 'products' ? Number(productsMinAvailable) : Number(sliderMinAvailable);
		const boundsMax =
			activeTab === 'products' ? Number(productsMaxAvailable) : Number(sliderMaxAvailable);
		// Treat an explicitly blank input as "no value" and fall back to bounds.
		let nextMin =
			draftMinprice === '' || draftMinprice === null || typeof draftMinprice === 'undefined'
				? boundsMin
				: Number.isFinite(Number(draftMinprice))
				? Number(draftMinprice)
				: boundsMin;
		let nextMax =
			draftMaxprice === '' || draftMaxprice === null || typeof draftMaxprice === 'undefined'
				? boundsMax
				: Number.isFinite(Number(draftMaxprice))
				? Number(draftMaxprice)
				: boundsMax;

		// Ensure applied values are within the available bounds
		nextMin = Math.min(boundsMax, Math.max(boundsMin, nextMin));
		nextMax = Math.min(boundsMax, Math.max(boundsMin, nextMax));
		const nextCats = Array.isArray(draftCatIds) ? draftCatIds : [];

		// Commit draft -> applied
		setMinprice(nextMin);
		setMaxprice(nextMax);
		setCatid(nextCats);
		if (activeTab === 'products') {
			productsRangeRef.current = { min: nextMin, max: nextMax };
			setProductsRange({ min: nextMin, max: nextMax });
		} else {
			servicesRangeRef.current = { min: nextMin, max: nextMax };
			setServicesRange({ min: nextMin, max: nextMax });
		}

		setCurrentPage(1);
		setHasMore(true);
		if (activeTab === 'products') {
			setProducts([]);
			// Use explicit committed values to avoid stale state reads
			filterProductsWL(branchIdToUse, 1, perPage, '', undefined, nextMin, nextMax);
		} else {
			setData([]);
			// NOTE: filterapp signature is (branchId, page, limit, signal, explicitMin, explicitMax, explicitCatIds)
			filterapp(branchIdToUse, 1, perPage, undefined, nextMin, nextMax, nextCats);
		}
		setShowFilters(false);
	};

	const handleCategorySelect = (value) => {
		// Categories apply only to services in this screen
		if (activeTab !== 'services') return;
		// Draft-only changes (no API calls)
		if (value === 'all') {
			setDraftCatIds([]);
			return;
		}
		setDraftCatIds((prev) => {
			const arr = Array.isArray(prev) ? [...prev] : [];
			const idx = arr.findIndex((x) => String(x) === String(value));
			if (idx >= 0) arr.splice(idx, 1);
			else arr.push(value);
			return arr;
		});
	};
	return (
		<PageWrapper>
			<Page container='fluid'>
				<SubHeader
					style={{
						alignContent: 'center',
						// On mobile, allow content to stack nicely
						padding: isMobile ? '8px 8px 0 8px' : undefined,
					}}>
					<SubHeaderLeft
						className='subheader-left'
						style={{
							marginBottom: isMobile ? 8 : 0,
							width: isMobile ? '100%' : 'auto',
						}}>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: isMobile ? 'space-between' : 'flex-start',
								gap: 8,
								width: '100%',
							}}>
							<a
								href={linkURL}
								target='_blank'
								className={classNames('text-decoration-none', {
									'link-dark': !darkModeStatus,
									'link-light': darkModeStatus,
								})}
								style={{
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}>
								<Logo width={200} />
							</a>
							{isMobile && <ThemeLangControls />}
						</div>
					</SubHeaderLeft>
					<div
						className={
							logbtn == 'ab' ? '' : 'subheader-right col-sm-auto subheader-right'
						}
						style={{
							display: 'flex',
							alignItems: 'center',
							width: isMobile ? '100%' : undefined,
							justifyContent: isMobile ? 'space-between' : undefined,
						}}>
						<div
							style={{
								display: 'flex',
								flexDirection: logbtn == 'ab' ? 'column' : 'row',
								alignItems: 'center',
								width: isMobile ? '100%' : undefined,
							}}>
							{branches && branches.length > 1 && (
								<div
									className='branch-select-wrapper'
									style={{
										fontSize: '12px',
										paddingTop: '6px',
										paddingBottom: '6px',
										marginRight: isMobile ? 0 : '16px',
										width: isMobile ? '100%' : '200px',
									}}>
									<FormGroup
										id='branch'
										className='col-12'
										style={{ marginBottom: 0 }}>
								<div style={{ display: 'flex', alignItems: 'center' }}>
											{isInitialServicesLoading || isInitialProductsLoading ? (
												<SelectSkeleton
													size='sm'
													width={isMobile ? '100%' : '12rem'}
												/>
											) : (
												<Select
													placeholder={`${t('Choose')}...`}
													list={branches}
													value={branch.data}
													style={{
														border: branch.error
															? '2px solid red'
															: '1px solid transparent',
														lineHeight: '20px',
														fontSize: '13px',
														width: isMobile
															? '100%'
															: 'webkit-fill-available',
														borderRadius: '6px',
														height: 36,
														padding: '4px 8px',
													}}
													onChange={handleBranchChange}
												/>
											)}
										</div>
									</FormGroup>
								</div>
							)}
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 8,
									width: isMobile ? '100%' : 'auto',
								}}>
								{!isMobile && (
									<div className='row g-3'>
										<div className='col-auto'>
											<ThemeLangControls />
										</div>
									</div>
								)}
								<div style={{ display: 'flex', width: isMobile ? '100%' : 'auto' }}>
									{hasGuestSession && !token?.session_key && (
										<div className='col-auto position-relative'>
											<Button
												style={{
													margin: '10px',
													flex: logbtn == 'ab' ? 1 : undefined,
												}}
												className='hdr-btn'
												color='warning'
												isLight
												icon='Cart'
												onClick={() => {
													navigate('/cart-guest');
												}}
											/>
											{(itemsCount || itemsCount !== 0) && (
												<span className='position-absolute top-0 start-90 translate-middle badge rounded-pill bg-danger'>
													{itemsCount < 99 ? itemsCount : '99+'}
												</span>
											)}
										</div>
									)}

									<Button
										style={{
											margin: '10px',
											flex: logbtn == 'ab' ? 1 : undefined,
										}}
										className='hdr-btn'
										color='success'
										isLight
										icon='Login'
										onClick={() => {
											const demoParam = searchParams.get('demo');
											const demoQuery =
												demoParam === 'true' ? '&demo=true' : '';
											navigate(`/login?type=login${demoQuery}`);
										}}>
										{t('Log In')}
									</Button>

									<Button
										style={{
											borderRadius: '10px',
											margin: '10px',
											flex: logbtn == 'ab' ? 1 : undefined,
										}}
										color='info'
										isLight
										icon='PersonAddAlt'
										onClick={() => {
											navigate(`/login?type=reg`);
										}}>
										{t('Sign Up')}
									</Button>
								</div>
							</div>
						</div>
					</div>
				</SubHeader>
				{showInitialHomeSkeleton ? (
					<div className='col-12 vslider-dev' style={{ marginTop: 24 }}>
						<Skeleton
							height={isMobile ? '220px' : '320px'}
							className='rounded-4 w-100'
						/>
					</div>
				) : (
					vslider && (
					<div className='col-12 vslider-dev' style={{ marginTop: 24 }}>
						<Carousel
							isHoverPause
							isRide
							rounded={0}
							height={height || '100%'}
							isDark={darkModeStatus}>
							{vslider?.map((d, i) => {
								return <SecondLayout d={d} i={i} key={i} />;
							})}
						</Carousel>
					</div>
					)
				)}
				<div
					style={{
						width: '100%',
						marginTop: '24px',
						marginBottom: '12px',
						display: 'flex',
						justifyContent: isMobile ? 'center' : 'flex-start',
						flexDirection: isMobile ? 'column' : 'row',
					}}>
					{showInitialHomeSkeleton ? (
						<>
							<div
								style={{
									alignItems: 'center',
									gap: 8,
									marginLeft: isMobile ? 0 : '12px',
									padding: '6px',
									maxWidth: isMobile ? '100%' : 'auto',
									width: isMobile ? '100%' : 'auto',
								}}>
								<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
									<SkeletonLine width='9rem' height='2.6rem' />
									<SkeletonLine width='9rem' height='2.6rem' />
								</div>
							</div>
							<div
								style={{
									marginLeft: isMobile ? 0 : 'auto',
									marginTop: isMobile ? 12 : 0,
									marginRight: isMobile ? 0 : 12,
									width: isMobile ? '100%' : 'auto',
								}}>
								<SkeletonLine
									width={isMobile ? '100%' : '8rem'}
									height='2.6rem'
								/>
							</div>
						</>
					) : (
						<>
							<div
								style={{
									//display: 'inline-flex',
									alignItems: 'center',
									gap: 8,
									marginLeft: isMobile ? 0 : '12px',
									background: darkModeStatus ? '#242731' : '#ffffff',
									padding: '6px',
									borderRadius: '999px',
									maxWidth: isMobile ? '100%' : 'auto',
									overflowX: isMobile ? 'auto' : 'visible',
									flexWrap: isMobile ? 'wrap' : 'nowrap',
								}}>
								<motion.div
									key={activeTab}
									initial={{ opacity: 0, y: -6 }}
									animate={{ opacity: 1, y: 0 }}
									exit={{ opacity: 0, y: -6 }}
									transition={{ duration: 0.18, ease: 'easeInOut' }}
									style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
									{(() => {
										const tabButtonStyle = {
											flex: isMobile ? '1 1 140px' : '0 0 140px',
											minWidth: isMobile ? 120 : 140,
											padding: '10px 8px',
											borderRadius: '999px',
											cursor: 'pointer',
											textAlign: 'center',
											fontWeight: 600,
											margin: '2px',
										};
										return (
											<div
												style={{
													...tabButtonStyle,
													color:
														activeTab === 'services'
															? '#ffffff'
															: darkModeStatus
															? '#e5e5e5'
															: '#222222',
													background:
														activeTab === 'services'
															? 'linear-gradient(135deg,#6c5dd3 0%,#9b74ff 100%)'
															: 'transparent',
													boxShadow:
														activeTab === 'services'
															? darkModeStatus
																? '0 2px 6px rgba(0,0,0,0.5)'
																: '0 2px 6px rgba(108,93,211,0.25)'
															: 'none',
													border:
														activeTab === 'services'
															? 'none'
															: `1px solid ${
																	darkModeStatus
																		? 'rgba(255,255,255,0.06)'
																		: 'rgba(0,0,0,0.06)'
															  }`,
												}}
												onClick={() => {
													if (controllerRef.current)
														controllerRef.current.abort();
													setActiveTab('services');
													setCurrentPage(1);
													setHasMore(true);
													setData([]);
													settotalRows(
														totalRowsServices !== null
															? totalRowsServices
															: null,
													);
													setShowFilters(false);
													fetchServices(branch.data);
												}}>
												{t('Services')}
												{activeTab === 'services' && (
													<span
														style={{
															marginLeft: 8,
															opacity: 1,
															background: '#ffffff',
															color: '#111',
															padding: '2px 8px',
															borderRadius: 999,
															fontSize: 12,
															boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
														}}>
														{`${
															totalRowsServices !== null
																? totalRowsServices
																: '...'
														}`}
													</span>
												)}
											</div>
										);
									})()}
									{(() => {
										const tabButtonStyle = {
											flex: isMobile ? '1 1 140px' : '0 0 140px',
											minWidth: isMobile ? 120 : 140,
											padding: '10px 8px',
											borderRadius: '999px',
											cursor: 'pointer',
											textAlign: 'center',
											fontWeight: 600,
											margin: '2px',
										};
										return (
											<div
												style={{
													...tabButtonStyle,
													color:
														activeTab === 'products'
															? '#ffffff'
															: darkModeStatus
															? '#e5e5e5'
															: '#222222',
													background:
														activeTab === 'products'
															? 'linear-gradient(135deg,#6c5dd3 0%,#9b74ff 100%)'
															: 'transparent',
													boxShadow:
														activeTab === 'products'
															? darkModeStatus
																? '0 2px 6px rgba(0,0,0,0.5)'
																: '0 2px 6px rgba(108,93,211,0.25)'
															: 'none',
													border:
														activeTab === 'products'
															? 'none'
															: `1px solid ${
																	darkModeStatus
																		? 'rgba(255,255,255,0.06)'
																		: 'rgba(0,0,0,0.06)'
															  }`,
												}}
												onClick={() => {
													if (controllerRef.current)
														controllerRef.current.abort();
													setActiveTab('products');
													setCurrentPage(1);
													setHasMore(true);
													setProducts([]);
													settotalRows(
														totalRowsProducts !== null
															? totalRowsProducts
															: null,
													);
													setShowFilters(false);
													fetchProductsWL(branch.data);
												}}>
												{t('Products')}
												{activeTab === 'products' && (
													<span
														style={{
															marginLeft: 8,
															opacity: 1,
															background: '#ffffff',
															color: '#111',
															padding: '2px 8px',
															borderRadius: 999,
															fontSize: 12,
															boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
														}}>
														{`${
															totalRowsProducts !== null
																? totalRowsProducts
																: '...'
														}`}
													</span>
												)}
											</div>
										);
									})()}
								</motion.div>
							</div>
							<div
								style={{
									marginLeft: isMobile ? 0 : 'auto',
									marginTop: isMobile ? 12 : 0,
									marginRight: isMobile ? 0 : 12,
								}}>
								<Button
									color='primary'
									isLight={!hasActiveFilters()}
									icon={priceBoundsLoaded ? 'Tune' : 'HourglassTop'}
									isDisable={!priceBoundsLoaded}
									onClick={() => priceBoundsLoaded && setShowFilters(true)}
									style={{
										borderRadius: 999,
										padding: '10px 14px',
										width: isMobile ? '100%' : 'auto',
										display: 'flex',
										alignItems: 'center',
										gap: 8,
									}}>
									{t('Filters')}
									{hasActiveFilters() && priceBoundsLoaded && (
										<span
											style={{
												marginLeft: 6,
												background: darkModeStatus
													? 'rgba(255,255,255,0.16)'
													: 'rgba(0,0,0,0.08)',
												color: darkModeStatus ? '#fff' : '#111',
												padding: '2px 8px',
												borderRadius: 999,
												fontSize: 12,
												fontWeight: 700,
												color: '#fff',
											}}>
											{`${activeFiltersCount()} ${t('Active')}`}
										</span>
									)}
								</Button>
							</div>
						</>
					)}
				</div>

				{/* Right filter panel */}
				<AnimatePresence>
					{showFilters && (
						<>
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
								transition={{ duration: 0.18 }}
								onClick={() => setShowFilters(false)}
								style={{
									position: 'fixed',
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									background: darkModeStatus
										? 'rgba(0,0,0,0.55)'
										: 'rgba(17,24,39,0.5)',
									backdropFilter: 'blur(3px)',
									zIndex: 9998,
								}}
							/>
							<motion.aside
								initial={{ x: 40, opacity: 0 }}
								animate={{ x: 0, opacity: 1 }}
								exit={{ x: 40, opacity: 0 }}
								transition={{ type: 'spring', stiffness: 320, damping: 30 }}
								style={{
									overflowX: 'hidden',
									position: 'fixed',
									top: 0,
									right: 0,
									height: '100vh',
									width: filterDrawerWidth,
									maxWidth: '92vw',
									background: darkModeStatus ? '#1f222b' : '#ffffff',
									borderLeft: darkModeStatus
										? '1px solid rgba(255,255,255,0.06)'
										: '1px solid rgba(0,0,0,0.08)',
									boxShadow: darkModeStatus
										? '0 20px 60px rgba(0,0,0,0.7)'
										: '0 20px 60px rgba(16,24,40,0.18)',
									zIndex: 9999,
									display: 'flex',
									flexDirection: 'column',
								}}>
								{/* Header */}
								<div
									style={{
										padding: '16px 16px 12px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										borderBottom: darkModeStatus
											? '1px solid rgba(255,255,255,0.06)'
											: '1px solid rgba(0,0,0,0.06)',
									}}>
									<div>
										<div style={{ fontWeight: 800, fontSize: 16 }}>
											{t('Filter')}
										</div>
										<div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
											{activeTab === 'products'
												? t('Products')
												: t('Services')}
										</div>
									</div>
									<Button
										color='light'
										isLight
										icon='Close'
										onClick={() => setShowFilters(false)}
										style={{ borderRadius: 999 }}>
										{t('Close')}
									</Button>
								</div>

								{/* Body */}
								<div style={{ padding: 16, flex: 1 }}>
									{/* Price range */}
									<div
										style={{
											padding: 14,
											borderRadius: 14,
											background: darkModeStatus
												? 'rgba(255,255,255,0.03)'
												: 'rgba(17,24,39,0.03)',
											border: darkModeStatus
												? '1px solid rgba(255,255,255,0.06)'
												: '1px solid rgba(0,0,0,0.06)',
										}}>
										<div style={{ fontWeight: 700, fontSize: 14 }}>
											{t('Price range (LKR)')}
										</div>
										<div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
											{t('Available')}: {formatCurrencyShort(priceBoundsMin)}{' '}
											- {formatCurrencyShort(priceBoundsMax)}
										</div>
										<div style={{ marginTop: 10 }}>
											<MuiRangeSlider
												min={priceBoundsMin}
												max={priceBoundsMax}
												lower={
													draftMinprice === '' ||
													draftMinprice === null ||
													typeof draftMinprice === 'undefined'
														? priceBoundsMin
														: Number(draftMinprice)
												}
												upper={
													draftMaxprice === '' ||
													draftMaxprice === null ||
													typeof draftMaxprice === 'undefined'
														? priceBoundsMax
														: Number(draftMaxprice)
												}
												onChange={({ lower, upper }) => {
													setDraftMinprice(lower);
													setDraftMaxprice(upper);
												}}
											/>
										</div>

										<div
											style={{
												display: 'grid',
												gridTemplateColumns: '1fr 1fr',
												gap: 10,
												marginTop: 12,
											}}>
											<div>
												<div
													style={{
														fontSize: 12,
														opacity: 0.75,
														marginBottom: 4,
													}}>
													{t('Min')}
												</div>
												<Input
													type='number'
													value={draftMinprice ?? ''}
													// Keep raw user input while typing so they can delete all digits.
													// We will validate/clamp when the user applies filters.
													onChange={(e) =>
														setDraftMinprice(e.target.value)
													}
													onFocus={handleMinFocus}
													onBlur={handleMinBlur}
													style={{ width: '100%' }}
												/>
											</div>
											<div>
												<div
													style={{
														fontSize: 12,
														opacity: 0.75,
														marginBottom: 4,
													}}>
													{t('Max')}
												</div>
												<Input
													type='number'
													value={draftMaxprice ?? ''}
													// Keep raw user input while typing so they can delete all digits.
													// We will validate/clamp when the user applies filters.
													onChange={(e) =>
														setDraftMaxprice(e.target.value)
													}
													onFocus={handleMaxFocus}
													onBlur={handleMaxBlur}
													style={{ width: '100%' }}
												/>
											</div>
										</div>
									</div>

									{/* Categories (services only) */}
									{activeTab === 'services' && cattableOption?.length > 0 && (
										<div
											style={{
												marginTop: 14,
												padding: 14,
												borderRadius: 14,
												background: darkModeStatus
													? 'rgba(255,255,255,0.03)'
													: 'rgba(17,24,39,0.03)',
												border: darkModeStatus
													? '1px solid rgba(255,255,255,0.06)'
													: '1px solid rgba(0,0,0,0.06)',
											}}>
											<div style={{ fontWeight: 700, fontSize: 14 }}>
												{t('Categories')}
											</div>
											<div style={{ marginTop: 10 }}>
												{cattableOption.map((opt) => {
													const isAll = opt.value === 'all';
													const selected = Array.isArray(draftCatIds)
														? draftCatIds
														: [];
													const checked = isAll
														? selected.length === 0
														: selected.some(
																(x) =>
																	String(x) === String(opt.value),
														  );
													return (
														<div
															key={String(opt.value)}
															style={{
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'space-between',
																padding: '10px 10px',
																borderRadius: 10,
																border: checked
																	? '1px solid rgba(108,93,211,0.5)'
																	: darkModeStatus
																	? '1px solid rgba(255,255,255,0.06)'
																	: '1px solid rgba(0,0,0,0.06)',
																marginBottom: 8,
																background: checked
																	? darkModeStatus
																		? 'rgba(108,93,211,0.18)'
																		: 'rgba(108,93,211,0.08)'
																	: 'transparent',
															}}>
															<span
																style={{
																	fontWeight: 600,
																	fontSize: 13,
																}}>
																{opt.text}
															</span>
															<Switch
																checked={checked}
																onChange={() =>
																	handleCategorySelect(opt.value)
																}
																sx={{
																	'& .MuiSwitch-switchBase.Mui-checked':
																		{
																			color: '#6c5dd3',
																		},
																	'& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
																		{
																			backgroundColor:
																				darkModeStatus
																					? 'rgba(108,93,211,0.55)'
																					: 'rgba(108,93,211,0.45)',
																			opacity: 1,
																		},
																	'& .MuiSwitch-track': {
																		backgroundColor:
																			darkModeStatus
																				? 'rgba(255,255,255,0.16)'
																				: 'rgba(17,24,39,0.18)',
																		opacity: 1,
																	},
																}}
															/>
														</div>
													);
												})}
											</div>
										</div>
									)}
								</div>

								{/* Footer actions */}
								<div
									style={{
										padding: 16,
										borderTop: darkModeStatus
											? '1px solid rgba(255,255,255,0.06)'
											: '1px solid rgba(0,0,0,0.06)',
										display: 'grid',
										gridTemplateColumns: '1fr 1fr',
										gap: 10,
									}}>
									<Button color='light' isLight onClick={clearFilters}>
										{t('Clear all')}
									</Button>
									<Button
										color='primary'
										// Disable until input validation passes AND price bounds are available
										isDisable={!arePriceInputsValid() || !priceBoundsLoaded}
										onClick={applyFilters}>
										{t('Filter')}
									</Button>
								</div>
							</motion.aside>
						</>
					)}
				</AnimatePresence>
				<div className='inner-wrapper'>
					<AnimatePresence mode='wait'>
						<motion.div
							key={activeTab}
							initial={{ opacity: 0, y: 8 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: -8 }}
							transition={{ duration: 0.22, ease: 'easeInOut' }}
							style={{ width: '100%', height: '-webkit-fill-available' }}>
							{activeTab === 'services' &&
								(isInitialServicesLoading ? (
									<div className='row g-3'>
										{Array.from({ length: 6 }, (_, index) => (
											<div className='col-12 col-md-6 col-lg-4' key={index}>
												<ServiceCardSkeleton />
											</div>
										))}
									</div>
								) : data && data.length > 0 ? (
									data.map((item) => (
										<div
											id={`home-item-${item.id}`}
											className='sub_inner_wrapper'
											key={item.id}
											onClick={() => {
												saveHomeCache(item.id);
												navigate(
													`/${layoutMenu.view_servwl.path}/${item.id}`,
												);
											}}>
											<CommonGridProductItem
												id={item.id}
												name={item.name}
												category={item.catname}
												currency={scurrency}
												img={JSON.parse(item.filepath)[0]}
												color='#46bcaa'
												price={item.price}
												pts={
													item.price_in_points !== null &&
													item.price_in_points !== 0 &&
													item.is_enable_points
														? item.price_in_points
														: null
												}
												editAction={() => {
													setEditPanel(true);
													handleEdit(item.id);
												}}
												deleteAction={() => handleRemove(item.id)}
												service_lable={item.service_lable || ''}
											/>
										</div>
									))
								) : showNoServices ? (
									<NoItems
										style={{ marginTop: '54px' }}
										message={t('No services found')}
									/>
								) : null)}

							{activeTab === 'products' &&
								(isInitialProductsLoading ? (
									<div className='row g-3'>
										{Array.from({ length: 6 }, (_, index) => (
											<div className='col-12 col-md-6 col-lg-4' key={index}>
												<ServiceCardSkeleton />
											</div>
										))}
									</div>
								) : products && products.length > 0 ? (
									products.map((item) => (
										<div
											id={`home-item-${item.id}`}
											className='sub_inner_wrapper'
											key={item.id}
											onClick={() => {
												saveHomeCache(item.id);
												navigate(
													`/${layoutMenu.view_productvwl.path}/${item.id}`,
												);
											}}>
											<CommonProductView
												id={item?.id}
												name={item?.name}
												quantity={item?.is_out_of_stock}
												currency={scurrency}
												img={item?.filepath[0] || ' '}
												color='#46bcaa'
												price={item?.price}
												linkPath={layoutMenu.view_productvwl.path}
												editAction={() => {
													setEditPanel(true);
													handleEdit(item?.id);
												}}
												deleteAction={() => handleRemove(item?.id)}
											/>
										</div>
									))
								) : showNoProducts ? (
									<NoItems message={t('No products found')} />
								) : null)}
						</motion.div>
					</AnimatePresence>
				</div>
				<div style={{ textAlign: 'center', padding: 12 }}>
					{!isListLoading &&
						isLoadingMore &&
						hasMore &&
						((activeTab === 'services' && data.length > 0) ||
							(activeTab === 'products' && products.length > 0)) && (
							<div className='row g-3 justify-content-center'>
								{Array.from({ length: 2 }, (_, index) => (
									<div className='col-12 col-md-6 col-lg-4' key={index}>
										<ServiceCardSkeleton />
									</div>
								))}
							</div>
						)}
					<div ref={bottomRef} style={{ height: 1 }} />
				</div>

				<AnimatePresence>
					{showScrollTop && (
						<motion.div
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: 20 }}
							transition={{ duration: 0.28 }}>
							<Popovers trigger='hover' desc={t('Back to top')}>
								<motion.button
									aria-label='Scroll to top'
									onClick={() => smoothScrollToTop(600)}
									whileHover={{ scale: 1.06 }}
									whileTap={{ scale: 0.96 }}
									style={{
										position: 'fixed',
										bottom: 52,
										right: 10,
										width: 52,
										height: 52,
										borderRadius: 999,
										background:
											'linear-gradient(135deg,#6c5dd3 0%,#9b74ff 100%)',
										color: '#fff',
										border: 'none',
										boxShadow: '0 10px 30px rgba(108,93,211,0.3)',
										cursor: 'pointer',
										zIndex: 9999,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}>
									<Icon icon='ArrowUpward' size='2x' />
								</motion.button>
							</Popovers>
						</motion.div>
					)}
				</AnimatePresence>
			</Page>
		</PageWrapper>
	);
};

export default Home;
